import React, { FC } from 'react';
import classNames from 'classnames';
import { Asset, CheckmarkIcon, CloseIcon } from '@clearcover/atlas';
import styles from './styles.module.css';

interface ChallengeIconProps {
  challenged?: boolean;
}

export const ChallengeIcon: FC<ChallengeIconProps> = ({
  challenged = false,
}) => {
  return (
    <Asset
      className={classNames(styles.icon, {
        [styles.check]: !challenged,
      })}
      icon={challenged ? CloseIcon : CheckmarkIcon}
      height={14}
      width={14}
      description={challenged ? 'challenged' : 'not challenged'}
    />
  );
};
